import React, { useEffect, useState } from 'react';
import BarChart from '../../core/Components/Barchart';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { useTranslation } from '../../core';
import { DateRangePicker } from "../../core/Components/DateRange";
import { addDays } from 'date-fns';
import { useSelector } from 'react-redux';
import * as dashboardSelectors from '../selectors';
import { getStockMoveData } from '../actions';
import _ from 'lodash';
import useAction from '../../core/services/UseAction';
import ChartContainer from '../../core/Components/ChartContainer';
import { withoutNullValue } from '../../core/services/chartDataFilter';

const StockMoveDataDashboard = () => {

  const { t } = useTranslation();

  const [selection, setSelection] = useState(
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection',
    }
  )

  const [usersSelection, setUserSelection] = useState([]);

  const getData = useAction(() => getStockMoveData(selection.startDate, selection.endDate), [selection]);
  const data = useSelector(dashboardSelectors.stockMoveData);
  const isLoadingStockMoveData = useSelector(dashboardSelectors.isLoadingStockMoveData);

  useEffect(() => {
    getData();
  }, [selection])

  const onDateRangeChange = (which) => {
    setSelection(which.selection)
  }

  const onUserSelection = (userName) => {
    if (_.find(usersSelection, elem => elem === userName)) {
      setUserSelection(_.filter(usersSelection, i => i !== userName))
    } else {
      setUserSelection([...usersSelection, userName])
    }
  }

  // const data = [
  //   {
  //     "userName": "User1",
  //     "stockMovesCompleted": 0,
  //     "stockMovesPerHour": 3,
  //     "itemsMoved": 5,
  //     "itemsMovedPerHour": 1,
  //     "hours": 25,
  //   },
  //   {
  //     "userName": "User2",
  //     "stockMovesCompleted": 23,
  //     "stockMovesPerHour": 8,
  //     "itemsMoved": 4,
  //     "itemsMovedPerHour": 4,
  //     "hours": 0
  //   },
  //   {
  //     "userName": "User3",
  //     "stockMovesCompleted": 5,
  //     "stockMovesPerHour": 1,
  //     "itemsMoved": 5,
  //     "itemsMovedPerHour": 2,
  //     "hours": 20
  //   },
  //   {
  //     "userName": "User4",
  //     "stockMovesCompleted": 40,
  //     "stockMovesPerHour": 6,
  //     "itemsMoved": 10,
  //     "itemsMovedPerHour": 4,
  //     "hours": 12
  //   },
  //   {
  //     "userName": "User5",
  //     "stockMovesCompleted": 5,
  //     "stockMovesPerHour": 0,
  //     "itemsMoved": 5,
  //     "itemsMovedPerHour": 4,
  //     "hours": 36
  //   },
  //   {
  //     "userName": "User6",
  //     "stockMovesCompleted": 0,
  //     "stockMovesPerHour": 2,
  //     "itemsMoved": 6,
  //     "itemsMovedPerHour": 4,
  //     "hours": 40
  //   }, {
  //     "userName": "User7",
  //     "stockMovesCompleted": 12,
  //     "stockMovesPerHour": 2,
  //     "itemsMoved": 3,
  //     "itemsMovedPerHour": 1,
  //     "hours": 38
  //   },
  //   {
  //     "userName": "User8",
  //     "stockMovesCompleted": 18,
  //     "stockMovesPerHour": 6,
  //     "itemsMoved": 2,
  //     "itemsMovedPerHour": 1,
  //     "hours": 80
  //   },
  //   {
  //     "userName": "User9",
  //     "stockMovesCompleted": 40,
  //     "stockMovesPerHour": 10,
  //     "itemsMoved": 18,
  //     "itemsMovedPerHour": 5,
  //     "hours": 21
  //   },
  //   {
  //     "userName": "User10",
  //     "stockMovesCompleted": 35,
  //     "stockMovesPerHour": 4,
  //     "itemsMoved": 30,
  //     "itemsMovedPerHour": 6,
  //     "hours": 8
  //   },
  //   {
  //     "userName": "User11",
  //     "stockMovesCompleted": 23,
  //     "stockMovesPerHour": 6,
  //     "itemsMoved": 0,
  //     "itemsMovedPerHour": 4,
  //     "hours": 34
  //   },
  //   {
  //     "userName": "User12",
  //     "stockMovesCompleted": 37,
  //     "stockMovesPerHour": 14,
  //     "itemsMoved": 3,
  //     "itemsMovedPerHour": 6,
  //     "hours": 36
  //   },
  //   {
  //     "userName": "User13",
  //     "stockMovesCompleted": 14,
  //     "stockMovesPerHour": 3,
  //     "itemsMoved": 8,
  //     "itemsMovedPerHour": 3,
  //     "hours": 10
  //   },
  //   {
  //     "userName": "User14",
  //     "stockMovesCompleted": 12,
  //     "stockMovesPerHour": 4,
  //     "itemsMoved": 23,
  //     "itemsMovedPerHour": 12,
  //     "hours": 18
  //   }
  // ]

  return (
    <Grid fluid className="dashboardContainer">
      <Row className="dashboardHeader">
        <Col xs>
          <DateRangePicker
            onChange={onDateRangeChange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            className={'PreviewArea'}
            months={3}
            ranges={[selection]}
            direction="horizontal"
          />
        </Col>
      </Row>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'stockMovesCompleted')}
          loading={isLoadingStockMoveData}
          title={t("stockMoveData.fields.stockMovesCompleted")}
          keys={['stockMovesCompleted']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'stockMovesPerHour')}
          loading={isLoadingStockMoveData}
          title={t("stockMoveData.fields.stockMovesPerHour")}
          keys={['stockMovesPerHour']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'itemsMoved')}
          loading={isLoadingStockMoveData}
          title={t("stockMoveData.fields.itemsMoved")}
          keys={['itemsMoved']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'itemsMovedPerHour')}
          loading={isLoadingStockMoveData}
          title={t("stockMoveData.fields.itemsMovedPerHour")}
          keys={['itemsMovedPerHour']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'hours')}
          loading={isLoadingStockMoveData}
          title={t("stockMoveData.fields.hours")}
          keys={['hours']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
    </Grid>
  );
};

export default StockMoveDataDashboard;